/**
 * `ez.t.item_deleted` — *When an item is deleted* (recipe 7004). Our `item.deleted` event also
 * carries archives (`payload.kind === 'archive'`), which this trigger must **not** fire on:
 * monday has a separate `item_archived` webhook event for that.
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
export const itemDeletedParams = z.object({});
export const itemDeletedTrigger = defineTrigger({
    id: 'ez.t.item_deleted',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When an item is deleted',
    paramsSchema: itemDeletedParams,
    subscribes: ['item.deleted'],
    assumed: true,
    references: () => [],
    matches: (event) => event.payload.kind !== 'archive' && event.payload.kind !== 'move_to_board',
    outputs: (event) => ({ itemId: event.itemId, boardId: event.boardId }),
});
//# sourceMappingURL=ez.t.item-deleted.js.map